module.exports = __webpack_public_path__ + "media/images/discounts-0fdff0144c16160091c30263c348999e.jpeg";